module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-Light.70b040e2.woff";